export default "__VITE_ASSET__sW0l8$7E__"